import { endpoints } from '../../../api/domains/endpoints';
import api from '../../../api';

export async function getSchedulesAPI ({  apiKey, traceId, widgetId, store, path}) {
    let url = endpoints().calendars;

    url = url.replace('{%id}', widgetId);
    console.log('url ', url);
    
    url = `${url}?apiKey=${apiKey}&traceId=${traceId}`

    if (path) {
        url = `${url}&path=${path}`;
    }

    return await api.get(
        url,
        {}, /* body */
        { traceId }, /* options */
        store,
    );  
}

export async function getSchedulesWithIdsAPI ({  apiKey, traceId, calIds, store, path}) {
    let url = endpoints().calendar;
    url = `${url}/${calIds}?apiKey=${apiKey}&traceId=${traceId}`;
    if (path) {
        url = `${url}&path=${path}`;
    }
    // url = 'https://testing-api.ecal.com/apiv3/calendar/63e49cfbd95fb3000e757624,6316ddbf89c84d000ed59aa7,62df42f10cd198000eb405bd,649a93b1589207000e2b18df,649ac9fcd81a2d000ef5b102,63e49fb8d95fb3000e757626,63e49ce59a9cf6000da0799c,63e49b5d9a9cf6000da0798a,649a93d4589207000e2b18e0,65d6ab975e5f6c0008caa50c,63e49c70d95fb3000e757621,63e49c87d95fb3000e757622,63e49caf9a9cf6000da07999,63e49cc09a9cf6000da0799a,63e49c97d95fb3000e757623,63e49cd29a9cf6000da0799b,649a93f3589207000e2b18e1,63e49d13d95fb3000e757625?apiKey=iO4vouUk2ZQ1FvdIKIrlZGdTSztVhkTcBhdRJkIxLX86242a0b&traceId=5b40f484-cf2e-4eea-be54-f44da3dda2e7';
    return await api.get(
        url,
        {}, /* body */
        { traceId }, /* options */
        store,
    );  
}

 